import {
    getDayOfTheMonth,
    getFormattedDate,
    getTheMonth
} from '../helpers/dateTimeHelpers';

export function getDecodedQueryString() {
    const {
        location: { search = '' } = {},
        decodeURIComponent = i => i
    } = global;

    return search
        .substring(1)
        .split('&')
        .reduce((o, pair) => {
            const [key, value = ''] = pair.split('=');

            if (key) {
                return {
                    ...o,
                    [key]: decodeURIComponent(value.replace(/\+/g, '%20'))
                };
            }

            return o;
        }, {});
}

export const getTermsText = closingDate => {
    if (!closingDate) {
        return 'Opening times may be subject to change. ';
    }

    const termsTime = getFormattedDate(closingDate, 'h:mma');
    const entriesDayOfMonth = getDayOfTheMonth(closingDate);
    const entriesMonth = getTheMonth(closingDate);

    return `Entries by ${termsTime} on ${entriesDayOfMonth} ${entriesMonth}, `;
};
